import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { requestGet } from '../../api/request';
import { MAIN_URL, HOME_EVENT } from '../../api/url';

const Gallery = () => {
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const navigate = useNavigate();
  const currentLanguage = useSelector((state) => state.languageReducer.current_language);

  const [data, setData] = useState([]);

  const getData = async () => {
    const response = await requestGet(HOME_EVENT, {
      event_type: 'photoreport',
      lang_id: currentLanguage.id,
    });

    if (response.success) {
      setData(response.data);
    }
  };
  const handleKeyDown = () => {};

  const scrollUp = () => {
    document.addEventListener('click', (e) => {
      const { target } = e;
      if (target.closest('.main-video img') || target.closest('.main-video-title')) {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    });
  };

  useEffect(() => {
    getData();
  }, [currentLanguage]);

  useEffect(() => {
    scrollUp();
  }, []);

  const showImage = (data) => {
    if (data.assets.length !== 0) {
      for (let i = 0; i < data.assets.length; i += 1) {
        if (data.assets[i].asset_type_id === 1) {
          return (
            <img
              onKeyDown={handleKeyDown}
              loading="lazy"
              role="presentation"
              alt={data.title}
              src={MAIN_URL.replace(/\/$/, '') + data.assets[0].new_path}
            />
          );
        }
      }
    }

    if ((data.assets.length === 0
      && data.news_flickr_image_relation.length !== 0)
      || (data.assets.length !== 0
      && data.assets[0].asset_type_id !== 1
      && data.news_flickr_image_relation.length !== 0)) {
      return (
        <img
          onKeyDown={handleKeyDown}
          loading="lazy"
          role="presentation"
          alt={data.title}
          src={data.news_flickr_image_relation[0].src}
        />
      );
    }
  };

  const showElement = (data) => {
    if (data.assets.length > 0
      || data.news_flickr_image_relation.length > 0) {
      return (
        <a
          href={`/gallery/${data.news_type_relation[0].news_type.name}/${data.id}`}
          onClick={(e) => {
            e.preventDefault();
            navigate(`/gallery/${data.news_type_relation[0].news_type.name}/${data.id}`);
          }}
        >
          {showImage(data)}
          <div
            onKeyDown={handleKeyDown}
            role="presentation"
            className="main-video-title"
          >
            <span className="text">{data.title}</span>
          </div>
        </a>
      );
    }
  };

  return data && data.length > 0 ? (
    <section className="main-section">
      <div className="container">
        <h3 className="main-section__title">{dictionary.menus.menu_4}</h3>
        <div className="main-video">
          <div className="main-video__item two">
            <div className="main-video__small">
              {showElement(data[0])}
            </div>
            <div className="main-video__small">
              {showElement(data[1])}
            </div>
            <div className="main-video__small">
              {showElement(data[2])}
            </div>
          </div>
          <div className="main-video__item three">
            <div className="main-video__head">
              <div className="main-video__big">
                {showElement(data[3])}
              </div>
            </div>
            <div className="main-video__footer">
              <div className="main-video__small">
                {showElement(data[4])}
              </div>
              <div className="main-video__small">
                {showElement(data[5])}
              </div>
            </div>
          </div>
          <div className="main-video__item three d-none d-lg-block">
            <div className="main-video__footer">
              <div className="main-video__small">
                {showElement(data[6])}
              </div>
              <div className="main-video__small">
                {showElement(data[7])}
              </div>
            </div>
            <div className="main-video__head">
              <div className="main-video__big">
                {showElement(data[8])}
              </div>
            </div>
          </div>
          <div className="main-video__item two d-none d-lg-block">
            <div className="main-video__small">
              {showElement(data[9])}
            </div>
            <div className="main-video__small">
              {showElement(data[10])}
            </div>
            <div className="main-video__small">
              {showElement(data[11])}
            </div>
          </div>
        </div>
        <div className="main-tab__button">
          <a
            onClick={(e) => {
              e.preventDefault();
              navigate('/gallery');
            }}
            href="/gallery"
            className="button button-update"
          >
            {dictionary.more}
          </a>
        </div>
      </div>
    </section>
  ) : null;
};

export default Gallery;
